var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNiacinamide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 6.21951C11.4148 6.21951 10.9026 5.70732 10.9026 5.12195V1.09756C10.9026 0.512195 11.4148 0 12.0001 0C12.5855 0 13.0977 0.512195 13.0977 1.09756V5.12195C13.0977 5.70732 12.5855 6.21951 12.0001 6.21951Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 24C11.4148 24 10.9026 23.4878 10.9026 22.9024V18.878C10.9026 18.2927 11.4148 17.7805 12.0001 17.7805C12.5855 17.7805 13.0977 18.2927 13.0977 18.878V22.9024C13.0977 23.5609 12.5855 24 12.0001 24Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9025 13.0976H18.8781C18.2927 13.0976 17.7805 12.5854 17.7805 12C17.7805 11.4147 18.2927 10.9025 18.8781 10.9025H22.9025C23.4878 10.9025 24 11.4147 24 12C24 12.5854 23.561 13.0976 22.9025 13.0976Z",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.12195 13.0976H1.09756C0.512195 13.0976 0 12.5854 0 12C0 11.4147 0.512195 10.9025 1.09756 10.9025H5.12195C5.70732 10.9025 6.21951 11.4147 6.21951 12C6.21951 12.5854 5.70732 13.0976 5.12195 13.0976Z",
    fill: "#333333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9025 8.19512C16.6098 8.19512 16.3171 8.12195 16.0976 7.90244C15.6586 7.46341 15.6586 6.80487 16.0976 6.36585L18.9512 3.51219C19.3903 3.07317 20.0488 3.07317 20.4878 3.51219C20.9269 3.95122 20.9269 4.60975 20.4878 5.04878L17.6342 7.90244C17.4878 8.12195 17.1951 8.19512 16.9025 8.19512Z",
    fill: "#333333"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.31701 20.8537C4.02432 20.8537 3.73164 20.7805 3.51213 20.561C3.07311 20.122 3.07311 19.4634 3.51213 19.0244L6.36579 16.1708C6.80481 15.7317 7.46335 15.7317 7.90237 16.1708C8.3414 16.6098 8.3414 17.2683 7.90237 17.7073L5.04871 20.4878C4.8292 20.7073 4.60969 20.8537 4.31701 20.8537Z",
    fill: "#333333"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7561 20.8537C19.4634 20.8537 19.1708 20.7805 18.9512 20.561L16.0976 17.7073C15.6586 17.2683 15.6586 16.6098 16.0976 16.1708C16.5366 15.7317 17.1951 15.7317 17.6342 16.1708L20.4878 19.0244C20.9269 19.4634 20.9269 20.122 20.4878 20.561C20.2683 20.7073 20.0488 20.8537 19.7561 20.8537Z",
    fill: "#333333"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.09749 8.19512C6.80481 8.19512 6.51213 8.12195 6.29262 7.90244L3.51213 5.04878C3.07311 4.60975 3.07311 3.95122 3.51213 3.51219C3.95115 3.07317 4.60969 3.07317 5.04871 3.51219L7.90237 6.36585C8.3414 6.80487 8.3414 7.46341 7.90237 7.90244C7.68286 8.12195 7.39018 8.19512 7.09749 8.19512Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNiacinamide);
export default __webpack_public_path__ + "static/media/niacinamide.ff857a87f2a782845d32d7aac3ce6df1.svg";
export { ForwardRef as ReactComponent };